// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"39":"802490f2","587":"97aba761"}[chunkId] + ".css";
};